import { useBoolean } from 'ahooks';
import classNames from 'classnames';
import type React from 'react';
import { useEffect, useRef } from 'react';

export interface ImageInputBoxProps {
  hoverable?: boolean;
  autoFocus?: boolean;
  disableFocus?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLElement>) => void;
  onClick?: () => void;
  children: React.ReactNode;
}

export const ImageInputBox = ({
  hoverable,
  autoFocus,
  disableFocus,
  onFocus,
  onClick,
  children,
}: ImageInputBoxProps) => {
  const divRef = useRef<HTMLDivElement>();
  const [focused, setFocused] = useBoolean();

  useEffect(() => {
    if (autoFocus && !disableFocus) {
      divRef.current.focus();
    }
  }, [autoFocus, disableFocus]);

  return (
    <div
      ref={divRef}
      tabIndex={disableFocus ? -1 : 0}
      className={classNames(
        'w-ds-67 flex rounded-ds-md',
        hoverable && 'hover:bg-ds-natural-100',
        onClick && 'cursor-pointer',
        focused &&
          !disableFocus &&
          'outline outline-ds-primary-300 outline-offset-[-1px] outline-1'
      )}
      onClick={onClick}
      onFocus={(e) => {
        onFocus?.(e);
        setFocused.setTrue();
      }}
      onBlur={setFocused.setFalse}
    >
      {children}
    </div>
  );
};
